import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { AppMenuItemComponent } from './app.menu-item.component';

@NgModule({
    imports: [
        CommonModule,
        AppSharedModule
    ],
    declarations: [
        AppMenuItemComponent
    ],
    exports: [
        AppMenuItemComponent
    ]
})
export class AppMenuItemModule {
}

